import { render, staticRenderFns } from "./NavbarBackend.vue?vue&type=template&id=38af6163&scoped=true&"
import script from "./NavbarBackend.vue?vue&type=script&lang=js&"
export * from "./NavbarBackend.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBackend.vue?vue&type=style&index=0&id=38af6163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af6163",
  null
  
)

export default component.exports